import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = createClient({
  projectId: "ch4xqcs2",
  dataset: "production",
  apiVersion: "2024-11-01",
  useCdn: true, // Set to false to prevent caching issues
  token: import.meta.env.VITE_SANITY_TOKEN,
  perspective: "published",
});

const builder = imageUrlBuilder(client);

// --- MODIFIED urlFor ---
export function urlFor(source) {
  if (source && source.asset && source.asset._ref) {
      return builder.image(source); // Return the real builder if valid
  }

  // If not valid, log a warning and return a more complete dummy object
  console.warn('urlFor received invalid source:', source);

  // Dummy object matching common chained methods
  const dummyUrl = '/placeholder-image.png'; // Path to your placeholder
  const dummyBuilder = {
      width: () => dummyBuilder,
      height: () => dummyBuilder,
      fit: () => dummyBuilder,
      crop: () => dummyBuilder,
      auto: () => dummyBuilder,
      format: () => dummyBuilder,
      quality: () => dummyBuilder,
      url: () => dummyUrl, // The final method returns the placeholder URL
      // Add any other methods you might chain (e.g., blur, dpr)
  };

  return dummyBuilder;
}
// Fetch all categories with related posts
export async function fetchCategoriesWithPosts() {
  const query = `*[_type == "category"]{
    _id,
    name,
    description,
    "imageUrl": image.asset->url,
    "posts": *[_type == "estatePost" && references(^._id)] | order(publishedAt desc)[0...5]{
      _id,
      title,
      slug,
      publishedAt,
      subtitle,
      "author": author->name,
      "authorImage": author->photo.asset->url,
      "imageUrl": mainImage.asset->url
    }
  }`;

  return await client.fetch(query);
}
export async function fetchReferenzen() {
  const query = `*[_type == "referenz" && showOnReferenzPage == true]{
    _id,
    name,
    description,
    quote,
    "avatar": avatar.asset->url,
    stars,
    title,
    "image": image.asset->url,
    date
  }`;

  return await client.fetch(query);
}

export async function fetchBeitraege() {
  const query = `*[_type == "post" && defined(slug.current)]{
      _id,
      title,
      slug,
      publishedAt,
      body,
      "imageUrl": image.asset->url
    }`;
  return await client.fetch(query);
}

export async function fetchCategories() {
  const query = `*[_type == "category"]{
       name,
    description,
    "imageUrl": image.asset->url,
    }`;
  return await client.fetch(query);
}
export async function fetchNavbarBeitraege() {
  const query = `*[_type == "estatePost" && showInNavbar == true]{
      _id,
      title,
      slug
    }`;
  return await client.fetch(query);
}

export async function fetchNavbarVerkaufenTipps() {
  const query = `*[_type == "estatePost" && selectedTipps_verkaufen == true]{
        _id,
        title,
        slug
      }`;
  return await client.fetch(query);
}
export async function fetchNavbarKaufenTipps() {
  const query = `*[_type == "estatePost" && selectedTipps_kaufen == true]{
          _id,
          title,
          slug
        }`;
  return await client.fetch(query);
}
export async function fetchNavbarVermietenTipps() {
  const query = `*[_type == "estatePost" && selectedTipps_vermieten == true]{
            _id,
            title,
            slug
          }`;
  return await client.fetch(query);
}
export async function fetchPostBySlug(slug) {
  if (!slug) throw new Error("Slug is required");

  const query = `*[_type == "estatePost" && slug.current == $slug][0]{
      title,
      subtitle,
      publishedAt,
"author": author->name,
"authorImage": author->photo.asset->url,      mainImage{
        asset->{
          _id,
          _ref,
          url
        },
        alt
      },
      content[]{
        ...,
        _type == "image" => {
          "url": asset->url,
          alt,
          caption
        }
      },
       relatedRatgeber->{
      title,
      description,
      "imageUrl": image.asset->url,
      "fileUrl": file.asset->url
    },
     category->{
      name,
      description,
      "imageUrl": image.asset->url,
    },
    merkmal,
      relatedPosts[]->{
        title,
        slug,
        

  mainImage{
        asset->{
          _id,
          _ref,
          url
        },
        alt
      },
      },
      seo
    }`;

  return await client.fetch(query, { slug });
}

// Fetch all posts for blog list
export async function fetchFilteredPosts({
  search = "",
  category = "",
  dateRange = [],
  sortBy = "publishedAt",
}) {
  const filters = [];
  if (search)
    filters.push(`title match "${search}*" || body match "${search}*"`);
  if (category) filters.push(`category->name == "${category}"`);
  if (dateRange.length === 2) {
    filters.push(
      `publishedAt >= "${dateRange[0]}" && publishedAt <= "${dateRange[1]}"`
    );
  }

  const query = `*[_type == "estatePost" ${
    filters.length ? `&& ${filters.join(" && ")}` : ""
  }] | order(${sortBy} desc){
      _id,
      title,
"author": author->name,
"authorImage": author->image.asset->url,
      "category":category->name,
      showInNavbar,
      slug,
      subtitle,
      publishedAt,
      "mainImageUrl": mainImage.asset->url,
      mainImage{
        alt
      }
    }`;

  return await client.fetch(query);
}
